import type { Socket } from "socket.io-client";

function update(update: Record<string, unknown>, socket: Socket): void {
	socket.emit("player:update", {
		data: update,
		emitCode: 84976,
	});
}

export default update;
